import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import conditionsCollection from 'modules/reports/store/collections/conditions'
import Condition from 'modules/reports/store/models/Condition'
import type { ConditionParams } from 'modules/reports/store/models/Condition'

export type FilterParams = ConditionParams[]

interface IFilter {
  [key: string]: any
}

class Filter extends Model<IFilter> {
  constructor(attr: IFilter = {}) {
    super(attr)
    makeObservable(this, {
      conditions: computed,
    })
  }

  static urlRoot() {
    return '/reports/filters'
  }

  static buildFromArray(filterArray: ConditionParams[]) {
    const conditions: Condition[] = filterArray.map((filter) => {
      const params = {
        path: filter.path,
        operator: filter.operator,
        arguments: filter.arguments,
      }

      return new Condition(params)
    })

    const filter = new Filter()
    filter.set({
      conditions,
    })

    return filter
  }

  get conditions(): Condition[] {
    // Dirty thing, while we are mapping templates
    // we dont have conditions, since is filter a many-to-many
    // relationship exposed by API, but in the case of templates
    // the filter are the conditions already
    if (this.has('conditions')) {
      return this.attributes.conditions
    }

    if (this.has('path')) {
      // FIXME: [ts-migration] Converting this return type from [this] to []
      return []
    }

    if (!this.has('id')) {
      return []
    }

    return conditionsCollection.filter({
      filter_id: this.attributes.id,
    })
  }

  serialize(): FilterParams {
    return this.conditions.map((condition) => condition.serialize())
  }
}

export default Filter
